// REF: https://api.typeform.com/forms/jGqHxg
let baseline = [
  {
    'id': 'TrNIFzOptDEp',
    'title': 'Please take a moment to review the questions below and answer to the best of your knowledge. Thank you for responding!',
    'ref': '93a7211a-764a-4893-af0d-e0760e8446f4',
    'properties': {
      'hide_marks': false,
      'button_text': 'Continue'
    },
    'type': 'statement'
  },
  {
    'id': 'VV34uuWUCSTJ',
    'title': '1. I have a routine for my injections.',
    'ref': '9255f1b8-4053-4059-813f-7a96a87c4297',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'BDS65i2YsxYm',
    'title': '2. I have been taking my injections on time.',
    'ref': 'fc8965bc-c49c-43cd-bbdc-41dcccb9feae',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'K70oMYPgj6nO',
    'title': '3. I am confident about administering my injections.',
    'ref': '7b54e313-99bb-400b-93ec-1150df5dcfd5',
    'properties': {
      'steps': 5,
      'start_at_one': true,
      'labels': {
        'left': 'Strongly Disagree',
        'right': 'Strongly Agree'
      }
    },
    'validations': {
      'required': false
    },
    'type': 'opinion_scale'
  },
  {
    'id': 'Bl9uAlZeWajx',
    'title': '4. Age:',
    'ref': 'b508114b-0ada-41bb-93ef-990edcb7c461',
    'properties': {
      'units': 'years old'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'ZldHwmPrFagS',
    'title': '5. Gender:',
    'ref': '95bd487a-be50-4529-90c9-d23a177db731',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'TiJ1seTaXJH8',
          'ref': '29618c8b-8a83-409d-b2f5-dde9603761e6',
          'label': 'Female'
        },
        {
          'id': 'BftsGgO1tFbm',
          'ref': '5526fc7e-0601-4430-abfd-6a7b28237cbf',
          'label': 'Male'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'or6MvS695O9p',
    'title': '6. Race:',
    'ref': 'c9805a34-84f5-4b08-936a-f82692534a33',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'Je0pTa2VzfOX',
          'ref': 'b23ab59f-05e2-47b0-929b-55ea445fd803',
          'label': 'Chinese'
        },
        {
          'id': 'r77hWnA0yHIK',
          'ref': 'e1accc25-82f7-44b7-8a8b-1b7aa15101ea',
          'label': 'Malay'
        },
        {
          'id': 'fLX7ojtCSwXz',
          'ref': '2e8a60d1-7fe1-4d98-abee-c6835dd9eb2f',
          'label': 'Indian'
        },
        {
          'id': 'jiyGdbJVNp5E',
          'ref': '4d13d70e-2db0-4b58-b835-5f5709f9da78',
          'label': 'Other'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'Nj4iPZrp9afD',
    'title': '7. Blood Pressure',
    'ref': '2b650981-bd6e-4322-8c68-34a74f15889c',
    'properties': {
      'units': 'mmHg'
    },
    'validations': {
      'required': false
    },
    'type': 'range'
  },
  {
    'id': 'TvCPGdBjhKvA',
    'title': '8. Total cholesterol:',
    'ref': '49269fb1-4ee7-4b05-b408-871245c21f86',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'x9AFmCVzZS1v',
    'title': '9. HDL:',
    'ref': 'aa85505f-bce4-4af1-8bcd-00152e8103a2',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'MAbtxYyQUsZ4',
    'title': '10. LDL:',
    'ref': 'eaa4b94c-d0ff-4524-ab74-8eb9c8e37335',
    'properties': {
      'units': 'mmol/L'
    },
    'validations': {
      'required': false
    },
    'type': 'number'
  },
  {
    'id': 'ScVBullS7XlH',
    'title': '11. Are you being treated for high blood pressure?',
    'ref': '915e68f2-d2ea-4b5b-a8c5-79c51fffde76',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'DwIVv27mM2hN',
          'ref': '28721bc2-f1eb-4059-af76-f9946e2aed82',
          'label': 'Yes'
        },
        {
          'id': 'DEl9AxNm47SF',
          'ref': 'b3721e0d-dee3-4996-944c-3fa8b5caefa4',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'dYxiCaNiyMx1',
    'title': '12. Are you being treated for diabetes?',
    'ref': 'f613aa4b-4c1a-4cba-8d1f-c9e29985a49a',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'FP223C2nA7UE',
          'ref': '7d363117-8571-41bf-8845-4ba49e4b2e1a',
          'label': 'Yes'
        },
        {
          'id': 'xF9MsAOvTJV6',
          'ref': '6421fb67-f94e-484b-81b3-1f7a6d1835c9',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  },
  {
    'id': 'AB9u8AA8XdFZ',
    'title': '13. Are you a smoker?',
    'ref': '47eb8fcb-d8fc-4c31-8700-a13aa689ff4e',
    'properties': {
      'randomize': false,
      'allow_multiple_selection': false,
      'allow_other_choice': false,
      'vertical_alignment': true,
      'choices': [
        {
          'id': 'FISsHw0SgU9P',
          'ref': 'd052c6b7-a5a7-4eb7-bf7b-a50d77f557eb',
          'label': 'Yes'
        },
        {
          'id': 'qQBWfRaflj87',
          'ref': 'fcb69035-a0a3-4ef5-a878-dd0ffc9becee',
          'label': 'No'
        }
      ]
    },
    'validations': {
      'required': false
    },
    'type': 'multiple_choice'
  }
]

export default baseline



// WEBPACK FOOTER //
// ./src/store/questionnaires/baselineQuestionnaire.js